import './About.css';
import SideMenu from '../SideMenu';
import AboutContent from './AboutContent';
import AboutExperience from './AboutExperience';
import SethL from '../../images/SethLI2P.jpg';
import DummyResume from '../../images/Portfolio2_DummyResume.pdf';
import VoicemailIcon from '../../images/Portfolio2VoicemailIcon.png';
import MailIcon from '../../images/Portfolio2MailIcon.png';
import ProfileIcon from '../../images/Portfolio2ProfileIcon.png';
import LocationIcon from '../../images/Portfolio2LocationIcon.png';

function About() {
  return (
    <div className = 'about'>
      <SideMenu />
      <div className = 'about-content'>
        <AboutContent />
        <AboutExperience />
      </div>   
    </div>
  );
}

export default About;